export const translations = {
    home: {
      en: {
        title: "Welcome to LoxPro",
        subtitle: "Professional Home Automation with Loxone",
        tagline: "Smart. Secure. Efficient.",
        description: "Experience seamless, intelligent living. LoxPro delivers state-of-the-art home automation using Loxone technology—tailored for comfort, security, and energy efficiency.",
        cta: "Request Consultation",
      },
      cz: {
        title: "Vítejte v LoxPro",
        subtitle: "Profesionální domácí automatizace s Loxone",
        tagline: "Chytré. Bezpečné. Efektivní.",
        description: "Zažijte bezproblémové a inteligentní bydlení. LoxPro přináší špičkovou domácí automatizaci s technologií Loxone – rešení na míru, pro pohodlí, bezpečnost a úsporu energie.",
        cta: "Nezávazná konzultace",
      },
    },
    about: {
      en: {
        title: "About LoxPro",
        description: "LoxPro delivers advanced home automation solutions using Loxone technology. Our certified team designs, installs, and maintains smart environments for comfort, security, and efficiency.",
        bullets: [
          "Certified Loxone Partner",
          "End-to-end project management",
          "Custom solutions for residential and business clients",
          "Integration with 3rd party systems like KNX, ModBus, Zigbee, and more",
        ],
      },
      cz: {
        title: "O LoxPro",
        description: "LoxPro nabízí pokročilá řešení domácí automatizace s technologií Loxone. Náš certifikovaný tým navrhuje, instaluje a udržuje chytrá prostředí pro pohodlí, bezpečnost a efektivitu.",
        bullets: [
          "Certifikovaný partner Loxone",
          "Kompletní projektové řízení",
          "Individuální řešení pro domácnosti i firmy",
          "Bohate zkusenosti s integraci systému s 3. stranami jako KNX, ModBus, Zigbee a další",
        ],
      },
    },
    benefits: {
      en: {
        title: "Why Choose Home Automation?",
        items: [
          { title: "Seamless Comfort", desc: "Automate lighting, climate, and shading for a truly effortless lifestyle." },
          { title: "All at one Place", desc: "Integrate and Control everything from one app—lighting, climate, security, and more." },
          { title: "Security", desc: "Advanced monitoring and alerts keep your home and data secure." },
          { title: "Energy Optimization", desc: "Smart scheduling and sensors save energy and reduce costs." },
          { title: "Smart Audio", desc: "Enjoy high-quality audio throughout your home with integrated sound systems." },
          { title: "Scalable Solutions", desc: "Our systems grow with your needs—future-proof and modular." },
        ],
      },
      cz: {
        title: "Proč zvolit domácí automatizaci?",
        items: [
          { title: "Maximální komfort", desc: "Automatizace osvětlení, klimatu a stínění pro skutečně pohodlný život." },
          { title: "Vše na jednom místě", desc: "Integrujte a ovládejte vše z jedné aplikace – osvětlení, klima, zabezpečení a další." },
          { title: "Bezpečnost", desc: "Pokročilý monitoring a upozornění chrání váš domov i data." },
          { title: "Úspora energie", desc: "Chytré plánování a senzory šetří energii i vaše náklady." },
          { title: "Chytrý zvuk", desc: "Vychutnejte si kvalitní zvuk v celém domě s integrovanými audio systémy." },
          { title: "Škálovatelná řešení", desc: "Naše systémy rostou s vašimi potřebami – jsou připraveny na budoucnost." },
        ],
      },
    },
    gallery: {
      en: {
        title: "Featured Projects",
        projects: [
          { img: '/img/smart_family_house.jpg', title: 'Modern house', desc: 'Full Loxone integration for lighting, climate, and security.' },
          { img: '/img/modern_kitchen.jpg', title: 'Kitchen lights', desc: 'Smart lighing in the kitchen.' },
          { img: '/img/smart_kitchen.jpg', title: 'Smart controll', desc: 'Integrated smart controller in the kitchen.' },
        ],
      },
      cz: {
        title: "Vybrané projekty",
        projects: [
          { img: '/img/smart_family_house.jpg', title: 'Moderní dům', desc: 'Kompletní Loxone integrace osvětlení, klimatu a zabezpečení.' },
          { img: '/img/modern_kitchen.jpg', title: 'Osvetleni kuchyne', desc: 'Chytré osvětlení v kuchyni.' },
          { img: '/img/smart_kitchen.jpg', title: 'Chytrý ovladač', desc: 'Integrovany chytry ovladac v kuchynske lince' },
        ],
      },
    },
    contact: {
      en: {
        title: "Contact LoxPro",
        name: "Your Name",
        email: "Your Email",
        phone: "Your Phone Number",
        message: "Your Message",
        send: "Send Message",
        orEmail: "Or email us:",
        statusSent: "Message sent! We'll be in touch soon.",
        statusError: "Sending failed. Please try again or email us directly.",
        statusVerifying: "Verifying…",
        statusSending: "Sending…",
        company: {
          header: "Company Information",
          name: "LoxPro - Ivan Vavrek",
          address: "Okrouhlo 228",
          city: "25401 Okrouhlo",
          country: "Czech Republic",
          phone: "+420 734 527 310",
          ico: "IČO: 14215781",
          dic: "DIČ: CZ9002269463"
        }
      },
      cz: {
        title: "Kontaktujte LoxPro",
        name: "Vaše jméno",
        email: "Váš e-mail",
        phone: "Vaše telefonní číslo",
        message: "Vaše zpráva",
        send: "Odeslat zprávu",
        orEmail: "Nebo nám napište na: info@loxpro.cz",
        statusSent: "Zpráva odeslána! Brzy se ozveme.",
        statusError: "Odeslání selhalo. Zkuste to prosím znovu nebo napište přímo na e-mail.",
        statusVerifying: "Ověřuji…",
        statusSending: "Odesílám…",
        company: {
          header: "Firemní údaje",
          name: "LoxPro - Ivan Vavrek",
          address: "Okrouhlo 228",
          city: "25401 Okrouhlo",
          country: "Česká republika",
          phone: "+420 734 527 310",
          ico: "IČO: 14215781",
          dic: "DIČ: CZ9002269463"
        }
      },
    },
  howItWorks: {
    en: {
      title: "How It Works",
      steps: [
        { number: "01", title: "Free Consultation", desc: "We visit or call to discuss your space and goals. No commitment, completely free." },
        { number: "02", title: "Custom Design", desc: "We prepare a tailored solution with a detailed price quote, delivered within a week." },
        { number: "03", title: "Installation", desc: "Our certified team installs and configures everything. Typically 2–5 days depending on scope." },
        { number: "04", title: "Ongoing Support", desc: "Remote monitoring, system expansions, and service available anytime after installation." },
      ],
    },
    cz: {
      title: "Jak to funguje",
      steps: [
        { number: "01", title: "Nezávazná konzultace", desc: "Navštívíme vás nebo zavoláme, probereme vaše prostory a cíle. Zdarma a bez závazků." },
        { number: "02", title: "Návrh řešení", desc: "Připravíme řešení na míru s podrobnou cenovou nabídkou do jednoho týdne." },
        { number: "03", title: "Instalace", desc: "Náš certifikovaný tým vše nainstaluje a nakonfiguruje. Obvykle 2–5 dní podle rozsahu." },
        { number: "04", title: "Podpora", desc: "Vzdálený dohled, rozšíření systému a servis kdykoliv po instalaci." },
      ],
    },
  },
  faq: {
    en: {
      title: "Frequently Asked Questions",
      items: [
        { q: "How much more does it cost vs. standard electrical?", a: "Loxone smart home installation is approximately 15–25% more than standard electrical work. This is offset by energy savings of 20–30%, increased property value, and the long-term comfort of full automation." },
        { q: "What will it actually bring me?", a: "A single app to control lighting, climate, shading, security, and audio throughout your home. You also get automated energy management, presence simulation when away, and a system that adapts to your habits over time." },
        { q: "Can it be installed in an existing home?", a: "Yes. Loxone supports retrofit installations without full rewiring. We assess your existing infrastructure and design a solution that minimises disruption to your home." },
        { q: "How long does installation take?", a: "Typically 2–5 working days depending on the size and scope of the project. We provide a detailed schedule before starting work." },
        { q: "Does it work without internet?", a: "Yes. Loxone runs entirely on your local network. Internet is only needed for remote access via the app when you're away from home." },
        { q: "What warranty do you provide?", a: "All hardware carries a 2-year warranty. We also offer support contracts covering remote diagnostics, software updates, and priority service callouts." },
      ],
    },
    cz: {
      title: "Časté dotazy",
      items: [
        { q: "O kolik je to dražší než klasická elektroinstalace?", a: "Instalace Loxone je přibližně o 15–25 % dražší než standardní elektroinstalace. Tuto investici kompenzují úspory energie 20–30 %, vyšší hodnota nemovitosti a dlouhodobý komfort plné automatizace." },
        { q: "Co mi to konkrétně přinese?", a: "Jednu aplikaci pro ovládání osvětlení, klimatu, stínění, zabezpečení a audia v celém domě. Automatické řízení spotřeby energie, simulaci přítomnosti při odjezdu a systém, který se přizpůsobí vašim návykům." },
        { q: "Lze instalovat do stávající nemovitosti?", a: "Ano. Loxone podporuje instalaci bez kompletního předělání elektroinstalace. Posoudíme vaši stávající infrastrukturu a navrhneme řešení s minimálním zásahem do vašeho domova." },
        { q: "Jak dlouho instalace trvá?", a: "Obvykle 2–5 pracovních dní podle velikosti a rozsahu projektu. Před zahájením prací vám poskytneme podrobný harmonogram." },
        { q: "Funguje systém bez internetu?", a: "Ano. Loxone běží zcela na lokální síti. Internet je potřeba pouze pro vzdálený přístup přes aplikaci, když nejste doma." },
        { q: "Jakou záruku poskytujete?", a: "Na veškerý hardware poskytujeme záruku 2 roky. Nabízíme také servisní smlouvy zahrnující vzdálenou diagnostiku, aktualizace softwaru a přednostní servisní výjezdy." },
      ],
    },
  },
  menu: {
    en: {
      home: "Home",
      about: "About",
      benefits: "Benefits",
      gallery: "Projects",
      contact: "Contact",
    },
    cz: {
      home: "Úvod",
      about: "O nás",
      benefits: "Výhody",
      gallery: "Projekty",
      contact: "Kontakt",
    }
  }
}